import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import FormGroup from './FormGroup';
import UserStore from '../stores/UserStore';

export default function ExchangeRates({ data = {} }) {
    const t = UserStore.getTranslation();
    const staticNames = t?.exchangeRates ?? {};
    const labels = t?.dataTable?.headers ?? {};
    const keys = useMemo(() => Object.keys(data), [data]);
    if (!keys.length) return null;

    return (
        <div className="ibox">
            <div className="ibox-title">
                <h5>{staticNames.title}</h5>
            </div>
            <div className="ibox-content">
                <div className="form-horizontal form-horizontal_flex">
                    {keys.map((k) => (
                        <FormGroup
                            key={k}
                            label={labels[k] || k}
                            value={String(data[k])}
                            horizontal
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

ExchangeRates.propTypes = { data: PropTypes.object };
